// starter accounts lose access to paid features (e.g. Axon) once the free trial ends
export function isFreeTrialExpired(user) {
  return !!user && user.account_type === 'Starter' && !!user.free_trial_expired;
}
